import { useEffect, useState } from 'react'
import { useIsFetching } from '@tanstack/react-query'

/**
 * Aviso de que se está viendo información guardada.
 *
 * La app arranca con lo último que se descargó, así que sin este aviso alguien
 * podría mirar un saldo de ayer creyendo que es el de ahora. Con dinero de por
 * medio, mostrar datos viejos sin decirlo es peor que no mostrar nada.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine)
  const fetching = useIsFetching()

  useEffect(() => {
    const goOnline = () => setOnline(true)
    const goOffline = () => setOnline(false)
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)
    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  if (online) return null

  return (
    // Va fuera del área que se desplaza, así que no necesita pegarse a nada:
    // se queda arriba mientras dure la desconexión.
    <div
      className="shrink-0 bg-[var(--color-warn)] px-4 py-1.5 text-center text-xs font-medium text-black"
      role="status"
    >
      Sin conexión · estás viendo los últimos datos guardados
      {fetching > 0 && ' · reintentando…'}
    </div>
  )
}
